/* eslint-disable no-undef, react/prop-types, react/no-danger */
import React from 'react';
import { graphql, Link } from 'gatsby';
import PageWrapper from '../components/PageWrapper';
import { css } from '@emotion/css';
import ButtonPrimary from '../components/Buttons';
import Helmet from "react-helmet";

const article = css`
  a{
    color : #ddd;
    font-weight : 1100;
    &: hover{
      color : #fff;
    }
  }
  table{
    margin-left:auto;    /* 左側マージンを自動的に空ける */
    margin-right:auto;   /* 右側マージンを自動的に空ける */
    display: block;
    border-collapse: collapse;
  }
  table tr:nth-child(even) {
    background: 111;
  }
  table tr:nth-child(odd) {          <TweetButton/>
  td,th{
    padding: 10px;
  }
`;
const Template = ({ data }) => {
  const { markdownRemark: post } = data;
  return (
    <PageWrapper>
      <Helmet
        meta={[
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@chernoyarsk' },
          { name: 'twitter:creator', content: 'HTKN' },
          { name: 'twitter:image', content: `https://chernoyarsk.web.app/static/ChernoyarskLOGO-a716394249348a2f8e54970d4ae18dfe.png` },
          { property: 'og:image', content: `https://chernoyarsk.web.app/static/ChernoyarskLOGO-a716394249348a2f8e54970d4ae18dfe.png` },
          { property: 'og:title', content: 'ちぇるのやるすく工廠' },
          { property: 'og:description', content: '更新情報です' },
          { property: 'og:url', content: `https://chernoyarsk.web.app/blog/${post.path}` }
        ]}
        title={post.frontmatter.title}
      />
        <div>
          <h1>{post.frontmatter.title}</h1>
          <h5>Written by {post.frontmatter.author.id}</h5>
          <div style={{ minHeight: '50vh' }} className={article} dangerouslySetInnerHTML={{ __html: post.html }} />
          <div class="twitter" style={{ textAlign: "center" }} >
            <a href="//twitter.com/share?ref_src=twsrc%5Etfw" className="twitter-share-button" data-size="large" data-text={post.frontmatter.title+"\n"} data-via="chernoyarsk" data-related="chernoyarsk" data-url={post.path} data-lang="ja" data-hashtags="ちぇるのやるすく工廠"></a>
          </div>
          <p style={{ textAlign: "center" }} >
            <Link to="/"><ButtonPrimary>一覧に戻る</ButtonPrimary></Link>
          </p>
          <blockquote class="twitter-tweet" data-theme="dark"></blockquote>
        </div>
    </PageWrapper>
  );
};

export const query = graphql`
  query BlogPostByPath($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        author {
          id
        }
      }
    }
  }
`;

export default Template;
